export const APP_LOADING = 'APP_LOADING';
export const APP_SUCCESS = 'APP_SUCCESS';
export const APP_ERROR = 'APP_ERROR';
export const SET_USER = 'SET_USER';
export const GET_USER_FROM_DB = 'GET_USER_FROM_DB';
export const GET_USER_FROM_DB_AND_UPDATE_STORE =
  'GET_USER_FROM_DB_AND_UPDATE_STORE';
export const LOGOUT = 'LOGOUT';
export const INIT_APP = 'INIT_APP';
export const INIT_APP_COMPLETE = 'INIT_APP_COMPLETE';
export const SET_ACTIVE_VISIT = 'SET_ACTIVE_VISIT';
export const SET_HISTORY = 'SET_HISTORY';
export const SET_UPCOMING_VISIT = 'SET_UPCOMING_VISIT';
export const SET_CURRENT_VISIT = 'SET_CURRENT_VISIT';
export const SORT_VISITS = 'SORT_VISITS';
export const SORT_ACTIVE_REPORTS = 'SORT_ACTIVE_REPORTS';
export const GET_ACTIVE_ASSESSMENTS = 'GET_ACTIVE_ASSESSMENTS';
export const SET_ACTIVE_ASSESSMENTS = 'SET_ACTIVE_ASSESSMENTS';
export const SET_SORTED_ASSESSMENTS = 'SET_SORTED_ASSESSMENTS';
export const SET_ACTIVE_ASSESSMENT = 'SET_ACTIVE_ASSESSMENT';
export const SET_ACTIVE_REPORT = 'SET_ACTIVE_REPORT';
export const SET_PROGRESS_BAR_PERCENT = 'SET_PROGRESS_BAR_PERCENT';
export const SET_UPCOMING_VISIT_ASSESSMENTS_NOTICE =
  'SET_UPCOMING_VISIT_ASSESSMENTS_NOTICE';
export const CHECK_IF_MOBILE = 'CHECK_IF_MOBILE';
